/*
* TODO: cleanup - integrate into other service, this one is kind of unnecessary    
* */

import {
    computed,
    inject,
    Injectable,
    InjectionToken,
    PLATFORM_ID,
    signal,
} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {
    BehaviorSubject,
    from,
    Observable,
    shareReplay,
    Subject,
    switchMap,
} from "rxjs";
import {ApiService} from "src/app/services/api.service";
import {ProductionLine} from "../interfaces/productionLine";
import {SelectionService} from "src/app/services/selection.service";

interface StorageState {
    error: string | null;
    userroles: UserroleDB[];
    productionLines: ProductionLine[];
}

export interface UserroleDB {
    id: string;
    created_at: string;
    name: string;
}

export const LOCAL_STORAGE = new InjectionToken<Storage>(
    "window local storage object",
    {
        providedIn: "root",
        factory: () => {
            return inject(PLATFORM_ID) === "browser"
                ? window.localStorage
                : ({} as Storage);
        },
    }
);

@Injectable({
    providedIn: "root",
})
export class StorageService {
    storage = inject(LOCAL_STORAGE);
    apiService = inject(ApiService);
    selectionService = inject(SelectionService);

    // sources
    error$ = new Subject<string>();
    refreshTrigger$ = new BehaviorSubject<void>(undefined);
    userroles$: Observable<UserroleDB[]> = this.refreshTrigger$.pipe(
        switchMap(() => this.getUserRoles()),
        shareReplay(1)
    );

    // state
    private state = signal<StorageState>({
        error: null,
        userroles: [],
        productionLines: [],
    });

    // selectors
    userroles = computed(() => this.state().userroles);
    productionLines = computed(() => this.state().productionLines);
    error = computed(() => this.state().error);

    constructor() {
        // console.log("Storage service initialized");
        // reducers
        this.userroles$
            .pipe(takeUntilDestroyed())
            .subscribe((userroles: UserroleDB[]) =>
                this.state.update((state) => ({
                    ...state,
                    userroles,
                }))
            );
    }

    loadUserroles() {
        this.refreshTrigger$.next();
    }

    private getUserRoles(): Observable<UserroleDB[]> {
        const roles = this.apiService.getUserRoles();
        return from(roles);
    }

    setError(error: string) {
        this.state.update((state) => ({...state, error}));
    }

    clearError() {
        this.state.update((state) => ({...state, error: null}));
    }
}
